import clientConfig from "../client.json";

export const DEFAULT_HUMAN_READABLE_STATUS = clientConfig.steps;

export const COUNT_STEPS = [
  "unknown",
  "accepted",
  "queued",
  "requested",
  "ready",
];

export const DEFAULT_AUDIO_VOLUME = 0.5;

export const SAS_TOKEN_ENDPOINT = clientConfig.sasTokenEndpoint;
